import React, {Component} from 'react';
import { connect } from 'react-redux';

import ItemNotification from './ItemNotification';

class ItemNotificationList extends Component {
    constructor(props) {
        super(props);

        this.state = {};
    }

    createList() {
        const { list } = this.props;

        const readyList = list.map((item, key) => 
            <ItemNotification 
                key={key}
                data={item}
            />
        );

        return readyList;
    }

    render() {

        return (
            <div className="item-list">
                {this.createList()}
            </div>
        )
    }
}

export default connect(
    null,
    null
)(ItemNotificationList)


// WEBPACK FOOTER //
// ./src/components/notification/ItemNotificationList.js